import { useQuery } from '@tanstack/react-query'

import { contractQueries } from '@/entities/contract'
import { DateRange, formatDate } from '@/shared/lib'

type Props = {
  roomId: number
  period: DateRange
  isExtend: boolean
  enabled: boolean
}

export const useContractEstimate = ({
  roomId,
  period,
  isExtend,
  enabled,
}: Props) => {
  const { data, isLoading } = useQuery({
    ...contractQueries.guestContractEstimate({
      rid: roomId,
      startDate: formatDate({
        date: period?.from,
        format: 'yyyy-MM-dd',
      }),
      endDate: formatDate({
        date: period?.to,
        format: 'yyyy-MM-dd',
      }),
      isExtend,
    }),
    enabled,
  })

  return {
    estimate: data,
    isLoading,
  }
}
